const PHARMACY_CERTIFICATE_VALIDITY_MONTHS = 24

export function isPharmacyCertificateOutdated(
  dateUploaded: string | undefined | null,
  now: Date = new Date(),
): boolean {
  if (!dateUploaded)
    return false

  const uploaded = new Date(dateUploaded)
  if (Number.isNaN(uploaded.getTime()))
    return false

  const expiresAt = new Date(uploaded)
  expiresAt.setMonth(expiresAt.getMonth() + PHARMACY_CERTIFICATE_VALIDITY_MONTHS)
  return now.getTime() >= expiresAt.getTime()
}
